type LicenseGetter = (() => string) | null;

class AgGridLicenceManager {
  private readonly _AG_LICENSE = 'CompanyName=Lendio,LicensedGroup=dev1,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-032850,SupportServicesEnd=12_September_2023_[v2]_MTY5NDQ3MzIwMDAwMA==e15191a27d344471143fee19553cf8d8';

  handleLicenseDist(getter: LicenseGetter) {
    return {
      applyLicense: function () {
        // eslint-disable-next-line prefer-rest-params
        return getter!.apply(this, arguments);
      },
      removeLicense: function () {
        getter = null;
      }
    }
  }

  getAgGridLicense: LicenseGetter = () => this._AG_LICENSE;

  manageLicense = this.handleLicenseDist(this.getAgGridLicense);
}

export const agGridLicense = new AgGridLicenceManager().manageLicense;
